module.exports = __webpack_public_path__ + "media/virtual-gallery/Process4-f917ccc7.png";